/* Recan theme — interactie
   Mobiel menu, productgalerij, aantal, AJAX toevoegen aan winkelmandje,
   cookiebanner en GA4-events. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ── GA4 / dataLayer ── */
  window.dataLayer = window.dataLayer || [];
  function track(event, params) {
    var payload = Object.assign({ event: event }, params || {});
    window.dataLayer.push(payload);
    if (window.gtag) window.gtag('event', event, params || {});
  }
  window.recanTrack = track;

  /* ── Toast ── */
  function toast(msg) {
    var t = $('#recan-toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* ── Mobiel menu ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#recan-burger')) {
      $('#recan-drawer').setAttribute('data-open', '');
      $('#recan-burger').setAttribute('aria-expanded', 'true');
      return;
    }
    if (e.target.closest('#recan-drawer-close') || e.target.id === 'recan-drawer') {
      $('#recan-drawer').removeAttribute('data-open');
      $('#recan-burger').setAttribute('aria-expanded', 'false');
      return;
    }

    /* Productgalerij */
    var th = e.target.closest('[data-gal]');
    if (th) {
      var main = $('#gal-main-img');
      if (main) {
        main.src = th.getAttribute('data-src');
        main.alt = th.getAttribute('data-alt') || '';
      }
      $$('[data-gal]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === th)); });
      return;
    }

    /* Aantal */
    var q = e.target.closest('[data-qty-step]');
    if (q) {
      var input = q.parentNode.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, Math.min(99, v + parseInt(q.getAttribute('data-qty-step'), 10)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* Cookiebanner */
    var ckb = e.target.closest('[data-ck]');
    if (ckb) {
      var v2 = ckb.getAttribute('data-ck');
      var prefs = $('#cookie-prefs');
      if (v2 === 'prefs') { prefs.hidden = !prefs.hidden; return; }
      if (v2 === 'all') { $('#ck-ana').checked = true; $('#ck-mark').checked = true; }
      if (v2 === 'nood') { $('#ck-ana').checked = false; $('#ck-mark').checked = false; }
      saveConsent($('#ck-ana').checked, $('#ck-mark').checked);
      $('#recan-cookie').hidden = true;
      return;
    }
    if (e.target.closest('#reopen-cookies')) {
      $('#cookie-prefs').hidden = false;
      $('#recan-cookie').hidden = false;
      return;
    }

    var ev = e.target.closest('[data-ev]');
    if (ev) track(ev.getAttribute('data-ev'), { label: (ev.textContent || '').trim().slice(0, 60) });
  });

  /* ── Toestemming cookies ── */
  function saveConsent(ana, mark) {
    try { localStorage.setItem('recan_consent', JSON.stringify({ ana: ana, mark: mark, t: Date.now() })); } catch (e) {}
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: ana, marketing: mark, preferences: ana }, function () {}
        );
      } catch (e) {}
    }
    track('cookie_consent', { analytics: ana, marketing: mark });
    toast('Je cookievoorkeuren zijn opgeslagen');
  }
  function readConsent() {
    try { return JSON.parse(localStorage.getItem('recan_consent') || 'null'); } catch (e) { return null; }
  }
  var banner = $('#recan-cookie');
  if (banner && !readConsent()) setTimeout(function () { banner.hidden = false; }, 900);

  /* ── Winkelmandje ── */
  function updateCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: form.querySelector('[name=id]').value,
          quantity: parseInt(form.querySelector('[name=quantity]') ? form.querySelector('[name=quantity]').value : 1, 10) || 1
        }]
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (!res.ok) { toast(res.data.description || 'Toevoegen lukte niet'); return; }
        var item = res.data.items ? res.data.items[0] : res.data;
        track('add_to_cart', {
          currency: form.getAttribute('data-currency') || 'EUR',
          value: (item.final_line_price || item.line_price || 0) / 100,
          quantity: item.quantity,
          item_id: String(item.product_id || ''),
          item_name: item.product_title || item.title || ''
        });
        toast(item.quantity + ' × ' + (item.product_title || 'product') + ' toegevoegd');
        refreshCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        toast('Er ging iets mis. Probeer het opnieuw.');
      });
  });

  /* Aantal wijzigen op de winkelmandpagina */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) {
      var form = input.closest('form');
      if (form) form.submit();
    }
  });

  /* Checkout-event */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name=checkout]')) track('begin_checkout', {});
  });

  refreshCart();
})();
